export default __webpack_public_path__ + "static/media/basicSkills.a811212a.jpg";